import { getSalesByItemReport } from "../../../services/sales/reporting";
import moment from 'moment';

export default {
    namespaced: true,
    state: {
        data: [],
        from : moment().startOf("month").format("YYYY-MM-DD"),
        to: moment().endOf("month").format("YYYY-MM-DD"),
        loading: false,
        errors: []
    },
    getters: {
        data: state => state.data,
        from: state => state.from,
        to: state => state.to,
        loading: state => state.loading,
        errors: state => state.errors,
        hasErrors: state => state.errors.length > 0
    },
    mutations: {
        data: (state, payload) => state.data = payload,
        from: (state, payload) => state.from = payload,
        to: (state, payload) => state.to = payload,
        loading: (state, payload) => state.loading = payload,
        errors: (state, payload) => state.errors = payload
    },
    actions: {
        get({commit, state}) {
            return new Promise((resolve, reject) => {
                commit("loading", true);
                commit("errors", []);
                getSalesByItemReport({from: state.from, to: state.to})
                    .then(response => {
                        commit("data", response.data);
                        resolve(response);
                    }).catch(error => {
                        let message = error.response ? error.response.data.message : error;
                        commit("errors", [message])
                        reject(error);
                    }).finally(() => {
                        commit("loading", false);
                    })
            });
        },
        updateParams({commit, dispatch}, payload) {
            commit("from", payload.from);
            commit("to", payload.to);
            dispatch("get");
        }
    }
}